import moment from "moment"

export default function (date, from, to) {
  if (!date) return ""
  return moment(date, from).format(to)
}
